import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHexagon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m30.227 22.578.05-13.045a2.955 2.955 0 0 0-1.468-2.564L17.54.4a2.954 2.954 0 0 0-2.955-.01L3.262 6.868a2.952 2.952 0 0 0-1.487 2.553l-.052 13.045a2.955 2.955 0 0 0 1.468 2.564l11.273 6.568a2.95 2.95 0 0 0 2.954.01l11.325-6.479a2.953 2.953 0 0 0 1.484-2.551z" /></svg>;
export default SvgHexagon;